import React from "react";
import './NotificationBar.css';

function NotificationBar({ sendMessage, notifications, updateNotification }) {

    return (
        <>
            <div className="notification-bar">
                {notifications.showTrade && <TradeNotification sendMessage={sendMessage} updateNotification={updateNotification} />}
                {notifications.showParty && <PartyNotification sendMessage={sendMessage} updateNotification={updateNotification} />}
            </div>
        </>
    )
}

function TradeNotification({ sendMessage, updateNotification }) {
    
    function sendNotification(msg) {
        sendMessage("600/trade " + msg);
        updateNotification(4);
    }


    return (
        <div className="notification trade">
            <p>Trade Invitation</p>
            <button className="notification-accept" onClick={(e) => sendNotification("accept")}>Accept</button>
            <button className="notification-decline" onClick={(e) => sendNotification("decline")}>Decline</button>
        </div>
    )
}

function PartyNotification({ sendMessage, updateNotification }) {

    function sendNotification(msg) {
        sendMessage("600/party " + msg);
        updateNotification(3);
    }

    return (
        <div className="notification party">
            <p>Party Invitation</p>
            <button className="notification-accept" onClick={(e) => sendNotification("accept")}>Accept</button>
            <button className="notification-decline" onClick={(e) => sendNotification("decline")}>Decline</button>
        </div>
    )
}

export default NotificationBar;